import logo from '@/assets/images/icon.png';
import { useTranslation } from '@/hooks/use-translation';
import { isDesktop } from '@/lib/platform';
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

export const Route = createFileRoute('/integrations-callback')({
  component: RouteComponent,
  validateSearch: z.object({
    result: z.string().optional(),
  }),
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');
  const search = useSearch({ from: '/integrations-callback' });
  const navigate = useNavigate();

  function closePopupFromWithin(result: string) {
    const origin = isDesktop() ? 'file://' : window.location.origin;
    if (result === 'success') {
      window.opener?.postMessage('close_integrations_popup_success', origin);
    } else {
      window.opener?.postMessage('close_integrations_popup', origin);
    }
    window.close();
  }

  useEffect(() => {
    if (search.result) {
      const result = search.result;
      setTimeout(() => closePopupFromWithin(result), 1000);
    } else {
      navigate({ to: '/' });
    }
  }, [search.result]);

  return (
    <div className="flex flex-col items-center py-10 gap-4">
      <div
        className={
          'flex items-center justify-center size-[50px] bg-linear-180 from-transparent via-secondary-60 to-secondary-60 rounded-full animate-spin'
        }
      >
        <div className="flex items-center justify-center size-[48px] rounded-full bg-white animate-[spin_1s_linear_infinite_reverse]">
          <img src={logo} alt="logo" className="h-8 w-auto" />
        </div>
      </div>
      <span className="font-inter font-medium">{t('integrations.redirect.text')}</span>
      <button
        type="button"
        onClick={() => closePopupFromWithin(search.result ?? 'failed')}
        className="font-semibold p-2 px-4 bg-primary-alpha-5 rounded-2xl text-body-14 cursor-pointer hover:opacity-70"
      >
        {t('integrations.redirect.close')}
      </button>
    </div>
  );
}
